import React, {useEffect} from "react";
import {Field, useForm, useFormState} from "react-final-form";
import InputField from "../fields/InputField";
import {composeValidators, required, limit} from "../../helpers/ValidateHelper";
import Error from "../fields/Error";
import QueryStorage from "../../../../../common/helpers/QueryStorage";

function Topic() {
    const {values} = useFormState();
    const {change} = useForm();

    useEffect(() => {
        const savedTopic = QueryStorage.get("topic");
        if (savedTopic) {
            change("topic", savedTopic);
        }
    }, [change]);

    useEffect(() => {
        if (values.topic !== undefined) {
            QueryStorage.set("topic", values.topic);
        }
    }, [values.topic]);

    return <div className="form-group">
        <div className="form-label">Topic</div>
        <Field
            name="topic"
            component={InputField}
            placeholder="Enter the title of your paper"
            className="control-input"
            validate={composeValidators(
                required('Please specify type topic'),
                limit('Maximum {limit} characters allowed. You\'ve used {count}.', 255)
            )}
        />
        <Error name="topic" />
    </div>
}

export default Topic;